<template>
  <van-image-preview
    v-model="showVideoOverlay"
    class="nx-video-preview"
    :images="videos.map(v => '')"
    @change="handleViewPreviewChange"
  >
    <template v-slot:cover>
      <div class="video-overlay">
        <video
          preload="metadata"
          controls
          style="max-height: 70vh"
        >
          <source :src="videos[previewIndex] + '#t=0.01'" />
        </video>
      </div>
    </template>
  </van-image-preview>
</template>

<script>
export default {
  name: 'NxVideoPreview',
  props: {
    videos: Array,
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      previewIndex: 0,
    };
  },
  computed: {
    showVideoOverlay: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      },
    },
  },
  watch: {
    showVideoOverlay() {
      this.pauseVideo();
    },
  },
  methods: {
    pauseVideo() {
      document.querySelectorAll('video').forEach(v => v.pause());
    },
    handleViewPreviewChange(i) {
      this.pauseVideo();
      this.previewIndex = i;
    },
  },
};
</script>

<style scoped lang="scss">
.video-overlay {
  height: 100vh;

  video {
    margin: 0 auto;
    width: 100vw;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
